import { render } from "./TemplateRename.vue?vue&type=template&id=18cb5f42"
import script from "./TemplateRename.vue?vue&type=script&lang=js"
export * from "./TemplateRename.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__